<template>
  <v-sheet>
    <v-row>
      <v-col cols="12" class="text-center">
        Please check your inbox for verification code
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn text @click="resendOtpEmail" :loading="resendLoading" :disabled="resendLoading">Resend email</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-otp-input v-model="otpInput" length="6" type="number"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn color="#00F9A7" :loading="otpLoading" :disabled="otpLoading || !otpIsValid" @click="confirmOtp">Confirm</v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import Bus from '@/bus';
export default {
  props: ['token', 'otp'],
  emits: ['emailVerified'],
  data: () => ({
    otpInput: '',
    otpLoading: false,
    resendLoading: false,
  }),
  computed: {
    otpIsValid() {
      return this.otpInput.length === 6;
    }
  },
  mounted() {
    this.otpInput = this.otp;
    if (this.otpInput) this.confirmOtp();
  },
  methods: {
    async confirmOtp() {
      console.log(process.env)
      this.otpLoading = true;
      try {
        const confirmData = {
          token: this.token,
          otp: this.otpInput
        };
        //TODO this will need to use a different API url
        const res = await this.$api.post('/email-verification/confirm-email-otp', confirmData);
        if (!res.data) throw new Error();
        this.$emit('emailVerified', res.data);
      } catch (e) {
        console.error(e);
        this.otpLoading = false;
        Bus.$emit('alert', 'error', 'Invalid verification code');
      }
    },
    async resendOtpEmail() {
      this.resendLoading = true;
      try {
        //TODO this will need to use a different API url
        await this.$api.post('/email-verification/resend-otp-email', { token: this.token });
        Bus.$emit('alert', 'success', 'Email has been resent successfully. Please check your email for the verification code');
      } catch (e) {
        console.error(e);
        Bus.$emit('alert', 'error', 'Failed to resend the email. Please contact support@systemx.net for assistance');
      } finally {
        this.resendLoading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
